/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_W1_87_49(e) {
  return (
    <tr
      key={e.usuarioId}
      className={`border-t border-(--border)`}
      children={[
        <td className={`p-3 text-(--text-h)`} children={e.nombre} />,
        <td className={`p-3`} children={e.terminadas} />,
        <td className={`p-3`} children={e.abandonadas} />,
        <td
          className={`p-3`}
          children={e.abandonadas ? `${e.progresoPromedioAlDejar}%` : `—`}
        />,
      ]}
    />
  );
}
